import React from 'react';
import { Link } from 'react-router-dom';

/** Phosphor ArrowLeft, regular. https://phosphoricons.com */
function ArrowLeft() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true">
      <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z" />
    </svg>
  );
}

export default function BackLink({ to, children, className }) {
  return (
    <Link to={to} className={className}>
      <ArrowLeft />
      {children}
    </Link>
  );
}
